import React, { createContext, useState, useCallback } from 'react';
import { getDataTravel } from '../services/dataTravelService';
import { getPromoterService } from '../services/getPromoterService';
import { Promoter } from '../types/promoter';
import { Trip } from '../types/trip';

export const DataTravelContext = createContext<{
  data: Trip | null,
  promoter: Promoter | null,
  loading: boolean,
  error: any | null,
  fetchData: (id: string) => Promise<{
    data: Trip;
    promoter: Promoter;
  }>,
  isReservation: boolean,
  shouldShowDateField: boolean
  isExperience: boolean
}>({
  data: null,
  promoter: null,
  loading: false,
  error: null,
  fetchData: async () => ({ data: {} as Trip, promoter: {} as Promoter }),
  isReservation: false,
  shouldShowDateField: false,
  isExperience: false
});

export const DataTravelProvider = ({ children }: { children: React.ReactNode }) => {
  const [data, setData] = useState<Trip | null>(null);
  const [promoter, setPromoter] = useState<Promoter | null>(null);
  const [isReservation, setIsReservation] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);
  const [shouldShowDateField, setShouldShowDateField] = useState(false);
  const [isExperience, setIsExperience] = useState(false)


  const fetchData = useCallback(async (id: string) => {
    setLoading(true);
    setError(null);
    try {
      const travelData = await getDataTravel(id);
      const promoterData = await getPromoterService();
      setData(travelData);
      setPromoter(promoterData);
      if (travelData.price?.is_reservation) {
        setIsReservation(travelData.price?.is_reservation)
      }
      if (travelData.should_show_date_field) {
        setShouldShowDateField(true);
      }

      if (travelData.type === "experience") {
        setIsExperience(true);
      }
      return {
        data: travelData,
        promoter: promoterData
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }

  }, []);

  return (
    <DataTravelContext.Provider value={{ data, promoter, loading, error, fetchData, isReservation, shouldShowDateField, isExperience }}>
      {children}
    </DataTravelContext.Provider>
  );
};
